import React, { FC, memo } from 'react';

import { Separator } from '@components/formStyles';

import { Container, Title } from './RulesStyle';
import RulesBody from './RulesBody';

export interface RulesProps {
  checkinBeginTime?: string;
  checkinEndTime?: string;
  optionalFee?: string;
  checkoutTime?: string;
  mandatoryFee?: string;
}

const Rules: FC<RulesProps> = ({
  mandatoryFee = '',
  optionalFee = '',
  checkinEndTime = '',
  checkinBeginTime = '',
  checkoutTime = '',
}) => {
  return (
    <Container>
      <Title>Giriş-Çıkış ve Önemli Bilgiler</Title>
      <RulesBody
        checkinBeginTime={checkinBeginTime}
        checkinEndTime={checkinEndTime}
        checkoutTime={checkoutTime}
        optionalFee={optionalFee}
        mandatoryFee={mandatoryFee}
      />
      <Separator />
    </Container>
  );
};

export default memo(Rules);
